import appConfig from "@/shared/config/app";

export const signInWithMicrosoftOauth = async () => {
  try {
    const publicToken = appConfig.stytchKey;
    const redirectUrl = `${window.location.origin}/auth`;
    const stytchBaseUrl = appConfig.stytchBaseUrl;
    if (stytchBaseUrl && redirectUrl && publicToken) {
      const stytchMicrosoftOauthUrl = `${stytchBaseUrl}/v1/b2b/public/oauth/microsoft/discovery/start?public_token=${publicToken}&discovery_redirect_url=${redirectUrl}`;
      window.location.href = stytchMicrosoftOauthUrl;
    }
  } catch (error) {
    throw new Error((error as Error).message);
  }
};
